import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { BreadcrumbItem, Breadcrumb as StrapBreadcrumb } from 'reactstrap'
import styled from 'styled-components'
import classnames from 'classnames'

import { queries } from '~/constants/mediaQuery'

function Breadcrumb({ paths, ...props }) {
  return (
    <BreadcrumbContainer {...props}>
      {paths.map(({ text, render: Component, to }, index) => (
        <BreadcrumbItem key={index}>
          {text ? (
            to ? (
              <Link
                className="d-flex align-items-center"
                style={{ fontWeight: 'bold' }}
                to={to}
              >
                {text}
              </Link>
            ) : (
              <span
                className={`d-flex align-items-center ${classnames({
                  'text-primary': index < paths?.length - 1,
                  'text-bold-600': index < paths?.length - 1,
                  'font-medium-3': true,
                })}`}
              >
                <FormattedMessage id={text} />
              </span>
            )
          ) : (
            <Component />
          )}
        </BreadcrumbItem>
      ))}
    </BreadcrumbContainer>
  )
}

const BreadcrumbContainer = styled(StrapBreadcrumb)`
  ol.breadcrumb {
    margin: 0;
    font-size: 20px;
    padding: 0 !important;
  }

  @media ${queries.less.xl} {
    ol.breadcrumb {
      font-size: 14px;
    }
  }
`

export default Breadcrumb
